class HoverDetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.querySelector('hover-details-content');

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));

    this.summary.addEventListener('mouseenter', () => {
      document.querySelectorAll('hover-details-disclosure').forEach((disclosure) => {
        disclosure.close();
      });

      this.mainDetailsToggle.setAttribute('open', '');
    });

    this.addEventListener('mouseleave', () => {
      this.close();
    });
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('hover-details-disclosure', HoverDetailsDisclosure);
